export const accountTypes = [
  { value: 'Checking', label: 'Checking' },
  { value: 'Savings', label: 'Savings' },
  { value: 'Corporate', label: 'Corporate' },
  { value: 'Corp Savings', label: 'Corp Savings' },
];
